function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 50,
  r: 10,
  fill: "#3be8b0"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "0.41666666666666663s",
  calcMode: "spline",
  keyTimes: "0;1",
  values: "10;0",
  keySplines: "0 0.5 0.5 1",
  begin: "0s"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill",
  repeatCount: "indefinite",
  dur: "1.6666666666666665s",
  calcMode: "discrete",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "#3be8b0;#ffb900;#6a67ce;#1aafd0;#3be8b0",
  begin: "0s"
}));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 50,
  r: 10,
  fill: "#3be8b0"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "1.6666666666666665s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "0;0;10;10;10",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "0s"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "cx",
  repeatCount: "indefinite",
  dur: "1.6666666666666665s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "16;16;16;50;84",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "0s"
}));

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 10,
  fill: "#1aafd0"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "1.6666666666666665s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "0;0;10;10;10",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-0.41666666666666663s"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "cx",
  repeatCount: "indefinite",
  dur: "1.6666666666666665s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "16;16;16;50;84",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-0.41666666666666663s"
}));

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 50,
  r: 10,
  fill: "#6a67ce"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "1.6666666666666665s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "0;0;10;10;10",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-0.8333333333333333s"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "cx",
  repeatCount: "indefinite",
  dur: "1.6666666666666665s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "16;16;16;50;84",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-0.8333333333333333s"
}));

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 50,
  r: 10,
  fill: "#ffb900"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "1.6666666666666665s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "0;0;10;10;10",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-1.2499999999999998s"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "cx",
  repeatCount: "indefinite",
  dur: "1.6666666666666665s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "16;16;16;50;84",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-1.2499999999999998s"
}));

function SvgLoad2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      margin: "auto",
      background: "rgb(255, 255, 255)",
      display: "block",
      shapeRendering: "auto"
    },
    width: "103px",
    height: "103px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoad2);
export default __webpack_public_path__ + "static/media/load-2.e5eb259e.svg";
export { ForwardRef as ReactComponent };